// extracted by mini-css-extract-plugin
var _1 = "SelectEntityItemAvatar-moduleavatar__zeGPU";
export { _1 as "avatar" }
